import React, { memo } from 'react'

import { IAlarpThreshold } from 'plugin-codaf-risk-ext-bowtie/types'

import { useBowtieLanguage, useBowtieStated } from '../../../../../hooks'
import { getAlarpStatusByName, getTopEventStatusColor, getTopEventStatusName } from '../../../../../utils'
import { bowtieTheme, topEventRadius } from '../../../../../utils/constants'
import { TopEventView } from '../../../../BowtieViews'
import { Pulse, MiddlePulseContentContainer, TextContainer } from './styles'

interface Props {
    title: string
    event: TopEventView
    showEvents?: boolean
    alarpThresholds?: IAlarpThreshold[]
    bowtieMethodType: string
}

export const MiddlePulse: React.FC<Props> = ({
    title,
    event: view,
    showEvents = true,
    alarpThresholds,
    bowtieMethodType
}) => {
    const i18n = useBowtieLanguage()
    const event = useBowtieStated(view)

    const functionGet = getAlarpStatusByName(alarpThresholds ?? [])

    return (
        <g className="bowtie-top-event">
            <Pulse r={topEventRadius} fill={bowtieTheme.topEvent.pulseColor} />
            <circle
                r={(topEventRadius * 2) / 2}
                fill={bowtieTheme.topEvent.topEventBackgroundColor}
                stroke={getTopEventStatusColor(event?.value, functionGet)}
                strokeWidth={2}
            />
            <foreignObject
                className="styledBowtieForeignObject"
                width={(topEventRadius - 25) * 2}
                height={topEventRadius * 2 - 45}
                x={-((topEventRadius * 2) / 2) + 25}
                y={-((topEventRadius * 2) / 2) + 25}
            >
                <MiddlePulseContentContainer>
                    <div className="top-event-title">{title}</div>
                    {showEvents && (
                        <>
                            <div className="bowtieStatus">
                                <div style={{ color: getTopEventStatusColor(event?.value, functionGet) }}>
                                    {getTopEventStatusName(event?.value, i18n, functionGet)}
                                </div>
                                <svg width={15} height={10.5}>
                                    <rect
                                        width={15}
                                        height={2.5}
                                        fill={getTopEventStatusColor(event?.value, functionGet)}
                                    />
                                    <rect
                                        x={2.5}
                                        y={4}
                                        width={10}
                                        height={2.5}
                                        fill={getTopEventStatusColor(event?.value, functionGet)}
                                    />
                                    <rect
                                        x={5}
                                        y={8}
                                        width={5}
                                        height={2.5}
                                        fill={getTopEventStatusColor(event?.value, functionGet)}
                                    />
                                </svg>
                            </div>
                            {bowtieMethodType === 'QUANTITATIVE' ? (
                                <>
                                    <div className="alarpcontainer">
                                        <div className="alarp">ALARP: </div>
                                        <div className="alarpvalue">
                                            {event?.value ? Number(event.value).toExponential(4) : '---'}
                                        </div>
                                    </div>

                                    <div className="limit">
                                        {i18n('Effectiveness Top')}:{' '}
                                        {Number(alarpThresholds[1]?.threshold ?? 0.001).toExponential(0)}
                                    </div>
                                    <div className="limit">
                                        {i18n('Effectiveness Bottom')}:{' '}
                                        {Number(alarpThresholds[0]?.threshold ?? 0.00001).toExponential(0)}
                                    </div>
                                </>
                            ) : null}
                        </>
                    )}
                </MiddlePulseContentContainer>
            </foreignObject>
        </g>
    )
}

export default memo(MiddlePulse)
